/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_ChatInputs */

const en_mk_cmp_r_chat = /** @type {(inputs: Mk_Cmp_R_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team chat inside the product`)
};

const id_mk_cmp_r_chat = /** @type {(inputs: Mk_Cmp_R_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat tim di dalam produk`)
};

/**
* | output |
* | --- |
* | "Team chat inside the product" |
*
* @param {Mk_Cmp_R_ChatInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_chat = /** @type {((inputs?: Mk_Cmp_R_ChatInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_ChatInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_chat(inputs)
	return en_mk_cmp_r_chat(inputs)
});